import React, { useState } from "react";
import Image from "react-bootstrap/Image";
import { Link } from "react-router-dom";
import useInsertFavorite from "../../hooks/useInsertFavorite";
import { useSelector } from "react-redux";
import styles from "../ListItemBuku/List.module.css";
import useSubsAllFavorites from "../../hooks/useSubsAllFavorites";
import Swal from "sweetalert2";
// import useSubsEachBook from "../../hooks/useSubsEachFavorite";

const ListItemBuku = (props) => {
  const { id_buku, sampul_buku, judul_buku } = props.data;

  const userData = useSelector((state) => state.user.userData);

  const { insertNewFavorite, insertFavoriteLoading, insertFavoriteError } =
    useInsertFavorite();

  const handleFavorit = (e) => {
    e.preventDefault();
    if (id_buku && userData) {
      Swal.fire({
        title: "Tambah ke buku favorit?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Ya",
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          insertNewFavorite({
            variables: {
              id_buku_favorit: id_buku,
              user_id: userData.user[0].id_user,
            },
          });
          Swal.fire("Berhasil!", "Masuk Ke Daftar Favorit", "success");
        } else if (result.isDenied) {
          Swal.fire("Tidak ada perubahan", "", "info");
        }
      });
    } else {
      Swal.fire("Tidak ada perubahan", "", "info");
    }
  };

  //

  return (
    <div className={styles.sampulsatu}>
      <div className={styles.hoversampul}>
        <div
          className={`${
            props.data.idbukufavorits[0]?.isFavorit
              ? styles.iconclick
              : styles.iconfavorit
          }`}
          onClick={handleFavorit}
        >
          <Image src={require("../../assets/bookmark.png")} alt="box" fluid />
        </div>
        <Link to={`/detailbuku/${id_buku}`}>
          <Image
            src={sampul_buku}
            alt="box"
            className={styles.sampulbuku}
            fluid
          />
        </Link>
      </div>
      <div>
        <h5 style={{ paddingTop: "20px" }}>{judul_buku}</h5>
      </div>
      <div>
        <Link to={`/detailbuku/${id_buku}`}>
          <p
            style={{
              color: "#32B9C4",
              fontSize: "15px",
              float: "right",
              paddingTop: "20px",
            }}
          >
            More...
          </p>
        </Link>
      </div>
    </div>
  );
};

export default ListItemBuku;
